import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { CheckScamPage } from './pages/CheckScamPage';
import { EmergencyProtocolPage } from './pages/EmergencyProtocolPage';
import { ProtocolPage } from './pages/ProtocolPage';
import { WhereToReportPage } from './pages/WhereToReportPage';
import { ReportTemplateGeneratorPage } from './pages/ReportTemplateGeneratorPage';
import { EvidenceSafetyPage } from './pages/EvidenceSafetyPage';
import { EducationPage } from './pages/EducationPage';
import { InternationalFrameworkPage } from './pages/InternationalFrameworkPage';
import { AboutPage } from './pages/AboutPage';
import { DisclaimerPage } from './pages/DisclaimerPage';
import { ChatAssessmentPage } from './pages/ChatAssessmentPage';
import { CyberQuizPage } from './pages/CyberQuizPage';
import { EventsPage } from './pages/EventsPage';
// Layout component to wrap pages with Header and Footer
function Layout() {
  return <div className="flex flex-col min-h-screen bg-background font-sans text-foreground antialiased" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow pt-24 sm:pt-[100px]" data-id="element-2">
        <Outlet data-id="element-3" />
      </main>
      <Footer data-id="element-4" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-5">
      <ScrollToTop data-id="element-6" />
      <Routes data-id="element-7">
        {/* Root redirect to default language (en) */}
        <Route path="/" element={<Navigate to="/en" replace data-id="element-9" />} data-id="element-8" />

        {/* Language Routes */}
        <Route path="/:lang" element={<Layout data-id="element-11" />} data-id="element-10">
          <Route index element={<HomePage data-id="element-13" />} data-id="element-12" />
          <Route path="check-scam" element={<CheckScamPage data-id="element-15" />} data-id="element-14" />
          <Route path="check-scam/:type" element={<CheckScamPage data-id="element-17" />} data-id="element-16" />
          <Route path="cyber-quiz" element={<CyberQuizPage data-id="element-19" />} data-id="element-18" />
          <Route path="events" element={<EventsPage data-id="element-21" />} data-id="element-20" />
          <Route path="chat-assessment/:type" element={<ChatAssessmentPage data-id="element-23" />} data-id="element-22" />
          <Route path="emergency-protocol" element={<EmergencyProtocolPage data-id="element-25" />} data-id="element-24" />
          <Route path="protocols/:type" element={<ProtocolPage data-id="element-27" />} data-id="element-26" />
          <Route path="where-to-report" element={<WhereToReportPage data-id="element-29" />} data-id="element-28" />
          <Route path="report-template-generator" element={<ReportTemplateGeneratorPage data-id="element-31" />} data-id="element-30" />
          <Route path="evidence-digital-safety" element={<EvidenceSafetyPage data-id="element-33" />} data-id="element-32" />
          <Route path="education" element={<EducationPage data-id="element-35" />} data-id="element-34" />
          <Route path="international-framework" element={<InternationalFrameworkPage data-id="element-37" />} data-id="element-36" />
          <Route path="about" element={<AboutPage data-id="element-39" />} data-id="element-38" />
          <Route path="disclaimer" element={<DisclaimerPage data-id="element-41" />} data-id="element-40" />
        </Route>

        {/* Catch all - redirect to root */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-43" />} data-id="element-42" />
      </Routes>
    </BrowserRouter>;
}